import { render, staticRenderFns } from "./Creditor_stand.vue?vue&type=template&id=6fba747c&scoped=true&"
import script from "./Creditor_stand.vue?vue&type=script&lang=js&"
export * from "./Creditor_stand.vue?vue&type=script&lang=js&"
import style0 from "./Creditor_stand.vue?vue&type=style&index=0&id=6fba747c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba747c",
  null
  
)

export default component.exports